import { NgModule, Injectable } from '@angular/core';
import { UIRouterModule } from '@uirouter/angular';
import { StateService, Transition } from '@uirouter/core';
import { ActiveFeatureService } from '@monsido/ng2/services/active-feature/active-feature.service';
import { MonUIRouterTransitionService } from '@monsido/ng2/services/ui-router-transition-service/ui-router-transition-service';

import { UsersComponent } from './users.component';

@Injectable({ providedIn: 'root' })
export class UsersAccessGuard {
    constructor (
        private activeFeatureService: ActiveFeatureService,
        private stateService: StateService,
        private monUIRouterTransitionService: MonUIRouterTransitionService,
    ) {}

    checkAccess (transition: Transition) {
        // Users section typically requires admin access
        if (this.activeFeatureService.isFeatureActive('admin_users') || this.activeFeatureService.isFeatureActive('admin_all')) {
            return true;
        }

        const params = transition.params();
        return this.monUIRouterTransitionService.onTransitionFinished(() => {
            return this.stateService.go('base.customer.admin.dashboard', params) as unknown as Promise<void>;
        });
    }
}

/**
 * Users routing configuration for Angular.
 * This module provides routing for the Admin Users section with proper access control.
 * Uses Angular service-based access guard following the established pattern.
 */

const usersStates = [
    // Access-controlled abstract route
    {
        name: 'base.customer.admin_old.users',
        url: '/users',
        abstract: true,
        data: {
            featureName: 'admin_users',
            redirectURI: 'base.customer.admin_old.dashboard',
            sidebar: 'admin',
            title: 'Acquia Web Governance - User List',
            htmlContent: '<div ui-view></div>',
        },
        resolve: [
            {
                token: 'usersAccess',
                deps: [UsersAccessGuard, Transition],
                resolveFn: (guard: UsersAccessGuard, transition: Transition) =>
                    guard.checkAccess(transition),
            },
        ],
    },
    // Child routes with components
    {
        name: 'base.customer.admin_old.users.index',
        url: '',
        views: {
            'content@base.customer.admin_old': {
                component: UsersComponent,
            },
        },
        data: {
            title: 'Acquia Web Governance - User List',
            htmlContent: '<div ui-view></div>',
        },
    },
];

@NgModule({
    imports: [UIRouterModule.forChild({ states: usersStates })],
    exports: [UIRouterModule],
})
export class UsersRoutingModule { }
